import { AttributeGroupUsage } from './../../article-type.model';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { IdGeneratorService } from 'src/common/services/id-generator.service';
import { ArticleType, ArticleTypeAttributeGroup } from '../../article-type.model';

@Component({
  selector: 'app-article-type-attribute-group-editor',
  templateUrl: './article-type-attribute-group-editor.component.html',
  styleUrls: ['./article-type-attribute-group-editor.component.scss']
})
export class ArticleTypeAttributeGroupEditorComponent implements OnInit {

  name = new DictionaryEntry();

  formGroup = new FormGroup({});

  articleType: ArticleType;

  attributeGroup: ArticleTypeAttributeGroup;

  sourceAttributeGroup: ArticleTypeAttributeGroup;

  possibleUsages = new Array<AttributeGroupUsage>(AttributeGroupUsage.ARTICLE, AttributeGroupUsage.POSITION, AttributeGroupUsage.COSTSPRICE);

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<ArticleTypeAttributeGroupEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService,
    private idGenerator: IdGeneratorService
  ) {

    // ...
    this.formGroup.addControl('sortValue', new FormControl('', []));
    this.formGroup.addControl('usage', new FormControl('', [Validators.required]));
    this.formGroup.addControl('groupKey', new FormControl('', []));

    this.articleType = data.articleType;
    this.sourceAttributeGroup = data.attributeGroup;
    if (data.attributeGroup != null) {
      this.attributeGroup = new ArticleTypeAttributeGroup(data.attributeGroup);
    } else {
      this.attributeGroup = new ArticleTypeAttributeGroup({});
    }

    this.formGroup.valueChanges.subscribe(
      value => {
        this.attributeGroup.usage = value.usage;
        this.attributeGroup.sortValue = value.sortValue;
        this.attributeGroup.groupKey = value.groupKey;
      }
    );

  }

  ngOnInit(): void {
    if (this.attributeGroup != null) {
      this.name = this.attributeGroup.name;
      this.formGroup.patchValue({
        usage: this.attributeGroup.usage,
        sortValue: this.attributeGroup.sortValue,
        groupKey: this.attributeGroup.groupKey
      });
    }
  }

  confirmDisabled(): boolean {
    return this.name == null || !this.name.checkValueExistsForLanguage('de');
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {

    if (this.articleType != null) {
      if (this.sourceAttributeGroup == null) { // new AttributeGroup
        const attributeGroup = new ArticleTypeAttributeGroup({ id: this.idGenerator.getNextId(), name: this.name, sortValue: this.attributeGroup.sortValue, usage: this.attributeGroup.usage, groupKey: this.attributeGroup.groupKey });
        this.articleType.attributeGroups.push(attributeGroup);
      } else { // merge working model back to source
        this.sourceAttributeGroup.name = this.attributeGroup.name;
        this.sourceAttributeGroup.sortValue = this.attributeGroup.sortValue;
        this.sourceAttributeGroup.groupKey = this.attributeGroup.groupKey;
        this.sourceAttributeGroup.usage = this.attributeGroup.usage;
      }
    }

    this.dialogRef.close(true);

  }

  public onNameChanged(dictionaryEntry: DictionaryEntry) {
    this.name = dictionaryEntry;
  }

}
